module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-status"
  }, [_c('div', {
    staticClass: "statusHeight",
    style: ({
      height: _vm.statusHeight + 'rem'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "title-bar"
  }, [_c('div', {
    staticClass: "title-name"
  }, [_vm._v(_vm._s(_vm.$store.webTitle))]), _vm._v(" "), (_vm.leftEle) ? _c('div', {
    staticClass: "left-ele alifont",
    class: _vm.leftEle.iconName,
    style: ({
      color: _vm.leftEle.color ? _vm.leftEle.color : '#333',
      fontSize: _vm.leftEle.fontSize ? _vm.leftEle.fontSize : '.24rem'
    }),
    on: {
      "click": _vm.leftEleMethod
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightEle) ? _c('div', {
    staticClass: "right-ele alifont",
    class: _vm.rightEle.iconName,
    style: ({
      color: _vm.rightEle.color ? _vm.rightEle.color : '#333',
      fontSize: _vm.rightEle.fontSize ? _vm.rightEle.fontSize : '.24rem'
    }),
    on: {
      "click": _vm.rightEleMethod
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightText) ? _c('div', {
    staticClass: "right-ele",
    style: ({
      color: _vm.rightText.color ? _vm.rightText.color : '#333',
      fontSize: _vm.rightText.fontSize ? _vm.rightText.fontSize : '.24rem'
    }),
    on: {
      "click": _vm.rightTextMethod
    }
  }, [_vm._v(_vm._s(_vm.rightText.text))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59ffcde8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/titleBar/baseTitleBar.vue
// module id = DDGw
// module chunks = 51